import React from "react";
import { BsTelephone, BsEnvelope } from "react-icons/bs";
import "./CustomerQuoteAgencyContactFooter.scss";

/**
 * כותרת "פרטי התקשרות" + שם/טל׳/מייל — אותו בלוק כמו בסוף OrderSummary להצעת לקוח.
 */
export default function CustomerQuoteAgencyContactFooter({ branding, className = "" }) {
  if (!branding) return null;
  const hasAny =
    branding.companyName ||
    branding.contactName ||
    branding.phone ||
    branding.email;
  if (!hasAny) return null;

  const agencyTelHref =
    branding?.phone != null && String(branding.phone).trim()
      ? `tel:${String(branding.phone).replace(/[^\d+]/g, "")}`
      : null;

  return (
    <footer
      className={["customer-quote-agency-footer", className].filter(Boolean).join(" ")}
      dir="rtl"
      aria-label="פרטי התקשרות"
    >
      <h3 className="customer-quote-agency-footer__title">פרטי התקשרות</h3>
      {branding.companyName ? (
        <p className="customer-quote-agency-footer__company">{branding.companyName}</p>
      ) : null}
      {branding.contactName ? (
        <p className="customer-quote-agency-footer__line">{branding.contactName}</p>
      ) : null}
      {branding.phone ? (
        <p className="customer-quote-agency-footer__line">
          <BsTelephone className="customer-quote-agency-footer__icon" aria-hidden />
          {agencyTelHref ? (
            <a href={agencyTelHref} className="customer-quote-agency-footer__link">
              {branding.phone}
            </a>
          ) : (
            <span>{branding.phone}</span>
          )}
        </p>
      ) : null}
      {branding.email ? (
        <p className="customer-quote-agency-footer__line">
          <BsEnvelope className="customer-quote-agency-footer__icon" aria-hidden />
          <a href={`mailto:${branding.email}`} className="customer-quote-agency-footer__link">
            {branding.email}
          </a>
        </p>
      ) : null}
    </footer>
  );
}
